import { PolluxFormConfig } from '../../../../../components/common/pollux-form-config/pollux-form-config';
import { PolluxFormDisabledEvaluator } from '../../../../../components/common/pollux-form-disabled-evaluator/pollux-form-disabled-evaluator';

export const copyValuationEventFormConfig: PolluxFormConfig[] = [
  {
    name: 'ProjectStdID',
    value: 'ProjectStdID',
    disabled: true
  },
  {
    name: 'Oid',
    value: 'Oid',
    disabled: true
  },
  {
    name: 'ProjectIDDescription',
    value: 'ProjectIDDescription',
    disabled: true
  },
  {
    name: 'DivisionOfPortfolio',
    value: 'DivisionOfPortfolio',
  },
  {
    name: 'ProjectStdID',
    value: 'ProjectStdID',
    disabled: true
  },
  {
    name: 'RefreshValuationDate',
    value: 'RefreshValuationDate',
    disabled: true
  },
  {
    name: 'SourceOid',
    value: 'SourceOid',
    disabled: true
  },
  {
    name: 'ValuationPeriodId',
    value: 'ValuationPeriodId'
  },
  {
    name: 'ValuationClientId',
    value: 'ValuationClientId',
    disabled: true
  },
  {
    name: 'Scenario',
    value: 'Scenario',
  },
  {
    name: 'PeriodOfValuationID',
    value: 'PeriodOfValuationID',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
  //  validators: [Validators.maxLength(256)]
  },
  {
    name: 'ValuationDate',
    value: 'ValuationDate',
 //   disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    isDate:true
  },
  {
    name: 'ValuationDate',
    value: 'ValuationDate',
    disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    //   disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    isDate: true
  },
  {
    name: 'ValuationDateDescription',
    value: 'ValuationDateDescription',
   // disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  },
  {
    name: 'periodOfValuationValue',
    value: 'periodOfValuationValue',
   // disabledTogglable: true,
   // disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly(), PolluxFormDisabledEvaluator.fieldIsSet('ImportAvailable', true)]
  },
  {
    name: 'refreshValuationDueDate',
    value: 'refreshValuationDueDate',
   // disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly(), PolluxFormDisabledEvaluator.fieldIsSet('ImportAvailable', true)]
  },

  {
    name: 'ClientManual',
    value: 'ClientManual',
   // disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
    //validators: [Validators.maxLength(256)]
  },
  {
    name: 'ProjectName',
    value: 'ProjectName',
  //  disabled: true
  },
  {
    name: 'Remark',
    value: 'Remark',
   // disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()],
   // validators: [Validators.min(1)]
  },
  {
    name: 'ValuationPortfolioName',
    value: 'ValuationPortfolioName',
    //disabledEvaluators: [PolluxFormDisabledEvaluator.formReadOnly()]
  }
  
];
